export default __webpack_public_path__ + "static/media/reset-page.cb5d20ed.png";